exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-header{padding:unset}.monitor-view{display:none}@media (min-width:768px){.mobile-view{display:none!important}.monitor-view{display:block!important}}@media print{#closeRegister{display:block!important;position:static!important;background:transparent!important}}", ""]);

// exports
